package pl.decks.personal.pages.ievp.foreword

import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariantBase
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.extendedByBase
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.vars.animation.TransitionDurationVars
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import pl.decks.personal.extensions.toSitePalette
import pl.decks.personal.styles.FontTypography
import pl.decks.personal.styles.SiteLayout

object ForewordStylesheet {
    object Vars {
        val pointBackgroundColor by StyleVariable<Color>()
        val pointVisitedBackgroundColor by StyleVariable<Color>()
        val pointStrokeColor by StyleVariable<Color>()
    }

    val CoverText = FontTypography.serif.extendedByBase {
        Modifier
            .fillMaxWidth()
            .lineHeight(FontTypography.LineHeight.Small)
            .padding(right = SiteLayout.Space.XSmall)
            .gap(SiteLayout.Space.XSmall)
    }

    object Points {
        sealed interface Kind : ComponentKind

        val Base = CssStyle<Kind> {
            base {
                Modifier
                    .borderRadius(SiteLayout.Rounding.Full)
                    .size(20.px)
                    .backgroundColor(Vars.pointBackgroundColor.value(Colors.Transparent))
                    .border(SiteLayout.Line.Normal, LineStyle.Solid, Vars.pointStrokeColor.value())
                    .transition {
                        property("size", "background-color", "border-style")
                        duration(TransitionDurationVars.Normal.value())
                        timingFunction(TransitionTimingFunction.EaseInOut)
                    }
            }
            hover {
                Modifier.size(30.px)
            }
            active {
                Modifier.size(30.px)
            }
        }
        val CurrentVariant = Base.addVariantBase {
            Modifier
                .size(30.px)
                .border(SiteLayout.Line.Normal, LineStyle.Dashed, Vars.pointStrokeColor.value())
        }
        val VisitedVariant = Base.addVariantBase {
            Modifier
                .size(10.px)
                .backgroundColor(Vars.pointVisitedBackgroundColor.value(Colors.Transparent))
        }
    }

    object Note {
        val Container = CssStyle.base {
            Modifier.fillMaxWidth().height(3.cssRem).padding(leftRight = SiteLayout.Space.XSmall)
        }
        val Text = CssStyle.base {
            Modifier
                .fontWeight(FontTypography.Weight.Medium)
                .textAlign(TextAlign.Center)
                .fontStyle(FontStyle.Italic)
                .color(colorMode.toSitePalette().accents.secondary)
        }
    }
}
